import './Button.css';

function Button({ variant = 'primary', children, ...props }) {
  return (
    <button className={`admin-btn admin-btn-${variant}`} {...props}>
      {children}
    </button>
  );
}

export default Button;
